module.exports = __webpack_public_path__ + "static/media/tavrika.f1569337.jpg";